module.exports = __webpack_public_path__ + "static/img/sp_5.7c39d06.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/sports/sp_5.png
// module id = 835
// module chunks = 1